import { setupApiClient } from './apiClient';

const api = setupApiClient();

export default api;
